import { useRouter } from 'next/router';
import React from 'react';

import { Breadcrumb } from '@sravni/react-design-system';
import { IOrganization } from '@sravni/types/lib/organizations';

import { useMetadata } from '../../hooks/metadata';

import styles from './seo-blocks.module.scss';

interface IProps {
  className?: string;
  text?: string;
  organization?: IOrganization;
}

const SeoBlocks: React.FC<IProps> = (props) => {
  const { text, className } = props;
  const router = useRouter();
  const { asPath } = router;

  const [pathname] = asPath.split('?');
  const metadata = useMetadata(pathname);

  return metadata ? (
    <div className={className}>
      <div className={styles.seoBlocksContainer}>
        {text && (
          <div className={styles.textContainer}>
            <div className={styles.textContent}>
              <p className={styles.text}>{text}</p>
            </div>
          </div>
        )}
        <Breadcrumb>
          <Breadcrumb.Item href="/">Сравни</Breadcrumb.Item>
          {metadata.breadcrumbs?.length &&
            metadata.breadcrumbs.map((el) => (
              <Breadcrumb.Item href={el.url} key={el.url}>
                {el.title}
              </Breadcrumb.Item>
            ))}
        </Breadcrumb>
      </div>
    </div>
  ) : null;
};

export default SeoBlocks;
